<<template>  
  <prop-panel @close="close">
    <p slot="header">{{rs["cFinger"]}}</p>
    <div style='width:560px;height:280px; left:0;top:0'>
      <div class="base-back" style="width:560px;height:280px; left:20px;top:10px; position: absolute; z-index=2;">
        <div style="position: absolute; top:10px; left: 50px;">
          <div @dbclick="delFinger(0)" @click="setFC(0)" :class='getFC(0)' style="left: 0px;  width: 25px; height:45px; top: 15px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div @dbclick="delFinger(1)" @click="setFC(1)" :class='getFC(1)' style="left: 32px; width: 25px; height:55px; top: 5px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div @dbclick="delFinger(2)" @click="setFC(2)" :class='getFC(2)' style="left: 62px; width: 25px; height:60px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div @dbclick="delFinger(3)" @click="setFC(3)" :class='getFC(3)' style="left: 95px; width: 25px; height:50px; top: 10px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div @dbclick="delFinger(4)" @click="setFC(4)" :class='getFC(4)' style="left: 125px; top: 50px;width: 30px; height:45px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 10px 0;"></div>
          <div style="border: 2px solid #fff; top:65px; width: 120px; height: 80px;position: absolute;font-size:36pt; border-radius: 0 0 10px 10px;">
            <p style="margin-left:40px;">L</p>
          </div>
        </div>

        <div style="position: absolute; top:10px;left: 300px;">
          <div @dbclick="delFinger(5)" @click="setFC(5)" :class='getFC(5)' style="left: 0px; top: 50px;width: 30px; height:45px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 10px;"></div>
          <div @dbclick="delFinger(6)" @click="setFC(6)" :class='getFC(6)' style="left: 35px;width: 25px; height:50px; top: 10px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div @dbclick="delFinger(7)" @click="setFC(7)" :class='getFC(7)' style="left: 68px;width: 25px; height:60px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div @dbclick="delFinger(8)" @click="setFC(8)" :class='getFC(8)' style="left: 98px;width: 25px; height:55px; top: 5px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div @dbclick="delFinger(9)" @click="setFC(9)" :class='getFC(9)' style="left: 130px;width: 25px; height:45px; top: 15px;position: absolute;border: 2px solid #fff; cursor:pointer; border-radius: 10px 10px 0 0;"></div>
          <div style=" border: 2px solid #fff; top:65px; left: 35px; width: 120px; height: 80px;position: absolute;font-size:36pt; border-radius: 0 0 10px 10px;">
          <p style="margin-left:40px;">R</p>
          </div>
        </div>
        <div v-show="clFinger" style="position: absolute; top:200px; left: 50px;">
          <p>请按压3次手指</p>
          <p>剩余按压次数：{{ftimes}}</p>
        </div>
        <div v-show="clFinger" style="position: absolute; width: 214px; height:30px;top:200px; left: 200px;border: 2px solid #fff;">
          <div :class='[ftimes<3? "fg-select":""]' style="position: absolute; top:0; left: 0;border: 1px solid #fff; height:26px; width: 70px;"></div>
          <div :class='[ftimes<2? "fg-select":""]' style="position: absolute; top:0; left: 70px;border: 1px solid #fff; height:26px; width: 70px;"></div>
          <div :class='[ftimes<1? "fg-select":""]' style="position: absolute; top:0; left: 140px;border: 1px solid #fff; height:26px; width: 70px;"></div>
        </div>
        <div v-show="clFinger" style="position: absolute; width: 314px; height:50px;top:240px; left: 200px;">{{msg}}</div>
      </div>      
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="delFinger" :disabled="this.selFinger==null || (this.selFinger!=null &&this.finger.indexOf(this.selFinger)<0)" type="button" class="btn btn-primary">{{rs["delFinger"]}}</button>
      <button @click.stop="cFinger" :disabled="this.selFinger == null || this.finger.indexOf(this.selFinger)>=0"  type="button" class="btn btn-primary">{{rs["cFinger"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  /*created: function() {  
    const fp = {}
      fp.bh= 3102
      fp.finger = "sssssssssssssssssss"
      fp.sq= 1

      this.$postData(this.url + "SaveFingerprint", fp, dt=>{
        if (dt.rs == 1) this.$alert("111")
        else this.$alert("指纹保存出错，请检查网络！")
      })
  },*/
  props:["detail", "finger", "rs", "url"],
  data(){
    return {
      clFinger: 0,
      ftimes:3,
      selFinger: null,
      msg:"",
      ws: null,
      fingerprint: null
    }
  },
  methods:{
    close: function() {
        //console.log(this.ws)
      if (this.ws) this.ws.send("closeFingerprint")
      try{
        this.ws.close()
      }catch(e){}
      this.$emit("close");
    },
    getFC(c){
      if (c==this.selFinger){
        if (this.finger && this.finger.indexOf(c)>=0) return "fg-exists-sel"
        else return "fg-select"
      }
      else if (this.finger && this.finger.indexOf(c)>=0) return "fg-exists"
      return ""
    },
    setFC(c){
      this.selFinger=c
    },
    checkDel(){
      return this.selFinger==null || (this.selFinger!=null &&this.finger.indexOf(this.selFinger)<0)
    },
    checkCF(){
      return this.selFinger == null || this.finger.indexOf(this.selFinger)>=0
    },
    delFinger(fg){
      //alert(typeof fg)
      //if(fg || fg==0) this.selFinger = fg

      if(this.finger.indexOf(this.selFinger)<0) return

      if(!this.$confirm("是否确认删除这个指纹？")) return 
      this.$getData(this.url + "DeleteFingerprint?bh="+this.detail.empId + "&sq=" + this.selFinger, dt=>{
        if (dt.rs == 1) this.finger.splice(this.finger.indexOf(this.selFinger),1)
        else this.$alert("删除指纹失败，请检查网络！")
      }) 
    },
    cFinger(){
      this.clFinger=1
      if (!this.ws || (this.ws && this.ws.readyState != 1)){
        const wsImpl = window.WebSocket || window.MozWebSocket
        this.ws = new wsImpl('ws://localhost:9527/')
        this.ws.onmessage =  evt =>{
          if (evt.data == -1) this.msg = "两次指纹差别太大，请重新按压指纹！"
          else if (evt.data ==2) this.msg = "初始化失败，请检查驱动程序是否已经安装、采集器是否已经连接电脑！"
          else if (evt.data ==3) this.msg = "找不到指纹采集器，请检查采集器是否已经连上电脑！"
          else if (evt.data ==4) this.msg = "无法打开采集器，请重新连接采集器！"
          else if (evt.data ==5) this.msg = "初始化失败，请重新安装采集器驱动程序！"
          else if (evt.data ==6) this.msg = "这个指纹已经采集，请换其他指纹！"
          else if (evt.data ==0) this.msg = "准备就绪，请按压指纹！"
          else if (evt.data ==1) {
            this.ftimes--
            this.msg="请继续按压指纹！"
            if (this.ftimes<=0) this.$showLoader()
          }
          else if (evt.data.indexOf("fingerprint:")>=0) {
            //this.ftimes--
            this.fingerprint = evt.data.substring(12)
            this.msg="指纹采集成功！"
            this.saveFingerprint()
          }
          else this.msg = evt.data
        }
        this.ws.onopen = ()=> {
          this.ftimes=3
          this.ws.send("getFingerprint")
        }
        this.ws.onclose = ()=>{
          //console.log("close websocket")
          this.ws = null
        }
        this.ws.onerror = ()=>{
          this.$alert("服务连接失败，请检查服务是否已打开！")
        }
      }
      else{
        this.ftimes=3
        this.ws.send("getFingerprint")
      }
      
    },
    saveFingerprint(){
      const fp = {}
      fp.bh=this.detail.empId
      fp.finger = this.fingerprint
      fp.sq= this.selFinger

      this.$postData(this.url + "SaveFingerprint", fp, dt=>{
        if (dt.rs == 1) {
          this.finger.push(this.selFinger)
          this.detail.fingerStatus=1
        }
        else this.$alert("指纹保存出错，请检查网络！")
      })
    },
  }
}
</script>

<style>
.fg-select{
  background-color: yellow;
}
.fg-exists{
  background-color: green;
}
.fg-exists-sel{
  background-color: yellowgreen;
}
</style>
